import { render } from "./Recommendation&ComplianceDetailsDialog.vue?vue&type=template&id=328477ff"
import script from "./Recommendation&ComplianceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./Recommendation&ComplianceDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__